import React from "react";
import { ModalWrapper, ModalContent, ModalHeader, ModalCloseButton, Form, BlueHeader, InputField, SubmitButton } from "../assets/styles/CommonStyles";



const BlogForm = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper>
      <ModalContent>
        <ModalHeader>
          <BlueHeader />
          <ModalCloseButton onClick={onClose}>X</ModalCloseButton>
        </ModalHeader>
        <Form>
          <InputField type="text" placeholder="Full Name:" />
          <InputField type="text" placeholder="Designation:" />
          <InputField type="email" placeholder="Business Email" />
          <InputField type="tel" placeholder="Contact Number:" />
          <InputField type="text" placeholder="Company:" />
          <InputField type="text" placeholder="Industry:" />
          <InputField type="text" placeholder="Expected Number of Checks (monthly):" /> 
        </Form>
           <SubmitButton>Submit</SubmitButton>
      </ModalContent>
    </ModalWrapper>
  );
};

export default BlogForm;
